import { render, staticRenderFns } from "./CallErrorVersion.vue?vue&type=template&id=90c6eec0"
import script from "./CallErrorVersion.vue?vue&type=script&lang=js"
export * from "./CallErrorVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports